const getMonthNameInArabic = (monthNumber) => {
  const arabicMonths = [
    "يناير", // January
    "فبراير", // February
    "مارس", // March
    "أبريل", // April
    "مايو", // May
    "يونيو", // June
    "يوليو", // July
    "أغسطس", // August
    "سبتمبر", // September
    "أكتوبر", // October
    "نوفمبر", // November
    "ديسمبر", // December
  ];

  // Ensure monthNumber is valid (1-12)
  if (monthNumber < 1 || monthNumber > 12) {
    return "رقم الشهر غير صالح"; // Invalid month number
  }

  return arabicMonths[monthNumber - 1];
};

export default getMonthNameInArabic;
